export default __webpack_public_path__ + "static/media/mimi6.6085c7d5.gif";